<template>
  <div class="position-ab">
    <div
      :class="
        !editStatus && billStatus != '0'
          ? 'ccui-app-iframe-no-operate-container'
          : 'ccui-app-box-iframe-operate-container'
      "
    >
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div
        :class="
          !editStatus && billStatus != '0'
            ? 'ccui-app-iframe-container-no-operate-detail'
            : 'ccui-app-iframe-container-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">
                评分表模板
              </el-button>
            </div>
            <el-checkbox
              class="chooseCheck"
              v-model="checked"
              :disabled="billStatus === '1' || joinExpertCount < 5"
              >去掉最低分和最高分</el-checkbox
            >
            <template v-if="editStatus">
              <div class="fr">
                <!-- <el-button type="single-number"  plain @click="addNew">新增</el-button> -->
                <el-button
                  type="single-number"
                  :disabled="isOld == 1"
                  plain
                  @click="addNew"
                  >新增</el-button
                >
                <el-button type="single-number" plain @click="editData"
                  >编辑</el-button
                >
                <el-button
                  type="single-number"
                  style="z-index: 1"
                  plain
                  :disabled="isOld == 1"
                  @click="copyData"
                  >复制</el-button
                >
                <el-button
                  type="single-number"
                  style="z-index: 1"
                  plain
                  :disabled="isOld == 1"
                  @click="deleteData"
                  >删除</el-button
                >
                <el-button
                  type="single-number"
                  style="z-index: 1"
                  @click="downloadPdf"
                  >下载模板</el-button
                >
                <el-upload
                  ref="importExcel1"
                  class="uploadClass"
                  :data="formData"
                  :disabled="isOld == 1"
                  :action="uploadForm.action"
                  :on-success="uploadSuccess"
                  :show-file-list="false"
                  :on-error="uploadError"
                  :before-upload="beforeAvatarUpload"
                  :headers="uploadForm.headers"
                  multiple
                >
                  <el-button :disabled="isOld == 1" plain type="single-number"
                    >导入评分模板</el-button
                  >
                </el-upload>

                <!--              <el-button type="single-number" plain>导出Excel</el-button>-->
                <!--              <el-button type="primary" plain>复制</el-button>-->
              </div>
            </template>
            <template v-else>
              <div class="fr">
                <el-button
                  type="single-number"
                  style="z-index: 1"
                  @click="exportPdf"
                  >导出Excel</el-button
                >
              </div>
            </template>
            <div class="clearfix"></div>
          </div>
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-x el-table--enable-row-hover"
            style="overflow: auto"
          >
            <table style="overflow: hidden; width: 100%" ref="scoreTable">
              <tr class="el-table__header-wrapper">
                <template v-if="editStatus">
                  <th class="wd6">
                    <div class="cell">选择</div>
                  </th>
                </template>
                <th class="wd2">
                  <div class="cell">序号</div>
                </th>
                <template v-if="subPackageFlag == '1'">
                  <th class="wd10">
                    <div class="cell">包件名称</div>
                  </th>
                </template>
                <th class="wd10">
                  <div class="cell">评审项目</div>
                </th>
                <th class="wd10">
                  <div class="cell">项目权重</div>
                </th>
                <th class="wd20">
                  <div class="cell">评审细则</div>
                </th>
                <th class="wd10">
                  <div class="cell">细则权重</div>
                </th>
                <th class="lastrightcell">
                  <div class="cell">评审标准</div>
                </th>
              </tr>
              <template v-if="tableData.length > 0">
                <template v-for="(item, index) in tableData">
                  <template v-for="(projectItem, pIndex) in item.sscScoreBOS">
                    <tr
                      class="el-table__body-wrapper is-scrolling-left el-table__row hover-row"
                      v-for="(detailItem,
                      dIndex) in projectItem.sscScoreItemBOS"
                      :key="index + 'e' + pIndex + 'a' + dIndex"
                    >
                      <!--选择框 start-->
                      <template v-if="editStatus && dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div class="cell wd6">
                            <el-checkbox
                              :key="item.packId + '' + projectItem.scoreItem"
                              v-model="projectItem.radio"
                              @change="
                                changeCheckbox(index, pIndex, dIndex, $event)
                              "
                            ></el-checkbox>
                          </div>
                        </td>
                      </template>
                      <!--选择框 end-->

                      <!--序号 start-->
                      <template v-if="pIndex == 0 && dIndex == 0">
                        <td
                          :rowspan="computeRowSpan(index)"
                          :class="
                            index == tableData.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div class="cell el-tooltip wd6" :title="index + 1">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <!--序号 end-->

                      <!--包件名称  start-->
                      <template v-if="subPackageFlag == '1'">
                        <template
                          v-if="!editStatus && pIndex == 0 && dIndex == 0"
                        >
                          <td
                            :rowspan="computeRowSpan(index)"
                            :class="
                              index == tableData.length - 1
                                ? 'lastbottomcell'
                                : ''
                            "
                          >
                            <div
                              class="cell el-tooltip wd10"
                              :title="item.packName"
                            >
                              {{ item.packName }}
                            </div>
                          </td>
                        </template>
                        <template
                          v-if="editStatus && pIndex == 0 && dIndex == 0"
                        >
                          <td
                            :rowspan="computeRowSpan(index)"
                            :class="
                              index == tableData.length - 1
                                ? 'lastbottomcell'
                                : ''
                            "
                          >
                            <div
                              class="cell el-tooltip wd10"
                              :title="item.packName"
                            >
                              {{ item.packName }}
                            </div>
                          </td>
                        </template>
                      </template>
                      <!--包件名称 end-->

                      <!--评审项目 start-->
                      <template v-if="dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div
                            class="cell el-tooltip wd10"
                            :title="projectItem.scoreItemStr"
                          >
                            {{ projectItem.scoreItemStr }}
                          </div>
                        </td>
                      </template>
                      <!--评审项目 end-->

                      <!--项目权重 start-->
                      <template v-if="dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div
                            class="cell el-tooltip wd10"
                            :title="projectItem.weight"
                          >
                            {{ projectItem.weight }}
                          </div>
                        </td>
                      </template>
                      <!--项目权重 end-->

                      <td
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div
                          class="cell el-tooltip wd20"
                          :title="detailItem.scoreRule"
                        >
                          {{ detailItem.scoreRule }}
                        </div>
                      </td>
                      <td
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div
                          class="cell el-tooltip wd10"
                          :title="detailItem.scoreWeight"
                        >
                          {{ detailItem.scoreWeight }}
                        </div>
                      </td>
                      <td
                        class="lastrightcell"
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div class="cell" :title="detailItem.scoreStandard">
                          {{ detailItem.scoreStandard }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              <template v-else>
                <tr class="el-table__empty-block">
                  <span>暂无数据</span>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </div>
      <template v-if="editStatus">
        <div class="operate">
          <el-button
            type="text"
            icon="icon-ccui-cancel"
            @click="
              getData();
              editStatus = false;
              radio = '';
              editScoreDataStr = {};
            "
            >取消</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-save"
            v-preventReClick
            @click="save(1)"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="save(2)"
            >生效</el-button
          >
        </div>
      </template>
      <template v-else>
        <template v-if="billStatus === '0'">
          <div class="operate">
            <el-button
              type="text"
              icon="icon-ccui-edit"
              @click="editStatus = true"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-agree"
              v-preventReClick
              @click="save(2)"
              >生效</el-button
            >
          </div>
        </template>
      </template>
      <el-dialog
        :title="editScoreScaleDevelopedTitle"
        :visible.sync="dialogTableVisible"
        width="1000px"
        v-if="dialogTableVisible"
      >
        <template v-if="editScoreDataStr.scoreItem === '5'">
          <editScoreScaleDevelopeds
            ref="editScoreScaleDeveloped"
            :editScoreDataStr="editScoreDataStr"
            :scoredPack="tableData"
            :scoreItemDisabled="scoreItemDisabled"
            :operateType="operateType"
          ></editScoreScaleDevelopeds>
        </template>
        <template v-else>
          <editScoreScaleDeveloped
            ref="editScoreScaleDeveloped"
            :editScoreDataStr="editScoreDataStr"
            :scoredPack="tableData"
            :scoreItemDisabled="scoreItemDisabled"
            :operateType="operateType"
          ></editScoreScaleDeveloped>
        </template>
        <div slot="footer">
          <el-button
            size="mini"
            type="default-mini"
            @click="dialogTableVisible = false"
            >取消</el-button
          >
          <el-button
            size="mini"
            type="primary-font-mini"
            v-preventReClick
            @click="confirmEditScoreScale"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import editScoreScaleDevelopeds from "@/app/subSourcingFlow/views/scoreScaleDeveloped/editScoreScaleDevelopeds.vue";
import editScoreScaleDeveloped from "@/app/subSourcingFlow/views/scoreScaleDeveloped/editScoreScaleDeveloped.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryScoreListApi,
  qryScoreBidPriceConfig,
  selectSchemeVersionById,
  scpDealExpertScoreFormulateApi,
  scpQryJoinExpertListApi,
  scpListPurchaseSchemePackageApi,
  scpQryBidEvaProcessStatusApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";
import Cookies from "js-cookie";
export default {
  name: "scpScoreScaleDeveloped",
  components: {
    editScoreScaleDeveloped,
    editScoreScaleDevelopeds,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      breadcrumbData: {
        titname: "评分表制定",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelShow: false,
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "development"
          : "setComplete", // 0:制定中 1：制定完成
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      editStatus: false, // 是否编辑状态
      tableData: [
        {
          radio: false,
          scoreItem: "1",
          scoreItemStr: "投标",
          sumForm: "101",
          weight: 80,
          sscScoreItemBOS: [
            { scoreRule: "投标报价", scoreWeight: 70, scoreStandard: "商务" },
            { scoreRule: "信用评价", scoreWeight: 2, scoreStandard: "商务" },
            { scoreRule: "企业业绩", scoreWeight: 3, scoreStandard: "商务" },
            {
              scoreRule: "投标文件的整体质量",
              scoreWeight: 5,
              scoreStandard: "商务"
            }
          ]
        }
      ],
      evaMethod: "",
      radio: "",
      dialogTableVisible: false,
      editScoreScaleDevelopedTitle: "新增评分项目",
      radioParentIndex: 0, // 单机选择的第几个
      radioIndex: 0, // 单机选择的第几个
      editScoreDataStr: {}, // 新增或编辑的数据
      operateType: "add", // add新增 edit编辑
      scoreItemDisabled: false, // 评审项目是否禁用
      packList: [], // 可评分包件
      checked: false,
      subPackageFlag: "1",
      saveItem: {}, // 后端需要的临时存，前端不展示
      joinExpertCount: 0, // 专家数，用于判断是否可勾选去掉最高分和最低分
      uploadForm: {
        // http://test01-eva.iccec.cn/apis/bid-scp/bidc/getImportExpertScoreTable
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/bid-scp/bidc/getImportExpertScoreTable"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      formData: {
        packs: null
      },
      isOld: ""
    };
  },
  watch: {
    editStatus: function(newValue, oldValue) {
      if (newValue) {
        this.editStatusIndex();
      }
    }
  },
  mounted() {
    this.evaMethod = JSON.parse(
      sessionStorage.getItem("bidEvaPrepareDetailData")
    ).evaMethod;
    this.getData();
  },
  methods: {
    init() {
      this.getData();
      this.reload();
    },
    getData() {
      let joinId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId;
      if (
        this.$router.history.current.query.evaPurStep === "801" ||
        this.$router.history.current.query.evaPurStep === "802"
      ) {
        joinId = sessionStorage.getItem("joinId");
      }
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: joinId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        this.labelShow = false;
        this.billStatus = res.data.data.billStatus;
        this.labelType =
          this.billStatus === "0" ? "development" : "setComplete"; // 0:制定中 1：制定完成
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.labelShow = true;
      });
      scpListPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        // packStatus1正常2、5流标 不显示流标的包件
        this.packList = res.data.data.purchaseSchemePackageList.filter(
          item => item.packStatus != "5" && item.packStatus != "2"
        );
        this.formData.packs = JSON.stringify(this.packList);
      });

      selectSchemeVersionById({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res1 => {
        this.isOld = res1.data.data.version;
        // 0是旧数据，1是新数据
        scpQryScoreListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          purStep: this.$router.history.current.query.evaPurStep
          // purStep: this.$router.history.current.query.menuKey,
          // evaPurStep: this.$router.history.current.query.evaPurStep
        }).then(res => {
          if (this.isOld == "1") {
            if (res.data.data.rows && res.data.data.rows.length > 0) {
              this.checked = res.data.data.sumForm === "102";
              res.data.data.rows.forEach((aItem, aIndex) => {
                aItem.sscScoreBOS.forEach((bItem, bIndex) => {
                  if (bItem.scoreItem == "5") {
                    let arr = [];
                    bItem.sscScoreItemBOS.forEach(item => {
                      if (item.free1 == "1") {
                        this.saveItem = item;
                      } else {
                        arr.push(item);
                      }
                    });
                    bItem.sscScoreItemBOS = arr;
                  }
                  bItem.radio = false;
                });
              });
              if (
                res.data.data.rows[0].sscScoreBOS &&
                res.data.data.rows[0].sscScoreBOS.length === 0
              ) {
                qryScoreBidPriceConfig({
                  schemeId: JSON.parse(
                    sessionStorage.getItem("expertSourceData")
                  ).schemeId
                }).then(res1 => {
                  console.log(JSON.stringify(res1.data.data), "res.data.data.");
                  let arr = [];
                  res1.data.data.sscScoreItemBOS.forEach(item => {
                    if (item.free1 == "1") {
                      this.saveItem = item;
                    } else {
                      arr.push(item);
                    }
                  });
                  res1.data.data.sscScoreItemBOS = arr;
                  res.data.data.rows[0].sscScoreBOS.push(res1.data.data);
                  res.data.data.rows.forEach((aItem, aIndex) => {
                    aItem.sscScoreBOS.forEach((bItem, bIndex) => {
                      bItem.radio = false;
                    });
                  });
                  this.tableData = res.data.data.rows;
                  console.log(this.tableData, "this.tableData...");
                });
              } else {
                this.tableData = res.data.data.rows;
              }
            }
          } else {
            this.checked = res.data.data.sumForm === "102";
            res.data.data.rows.forEach((aItem, aIndex) => {
              aItem.sscScoreBOS.forEach((bItem, bIndex) => {
                bItem.radio = false;
              });
            });
            this.tableData = res.data.data.rows;
          }
        });
      });

      // 在专家不少于5个的时候才可勾选(即去掉后不可少于3个)
      scpQryJoinExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        bidEvaId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .bidEvaId
      }).then(res => {
        this.joinExpertCount = res.data.data.rows.length;
      });
    },
    // 计算合并的行
    computeRowSpan(index) {
      let computeRowSpan = 0;
      this.tableData[index].sscScoreBOS.forEach(projectItem => {
        computeRowSpan += projectItem.sscScoreItemBOS.length;
      });
      return computeRowSpan;
    },
    //删除操作
    deleteData() {
      if (
        this.tableData[this.radioParentIndex].sscScoreBOS[this.radioIndex]
          .scoreItem == "5"
      ) {
        return this.$message.error("此评审项目不能删除");
      }
      this.operateType = "delete";
      if (this.radio !== "") {
        this.$confirm("您确定要删除选中行吗？", "删除", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        })
          .then(() => {
            this.tableData[this.radioParentIndex].sscScoreBOS.splice(
              this.radioIndex,
              1
            );
            this.editStatusIndex();
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "请选择要删除的评审项目！",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    addNew() {
      // 如果是空的
      this.editScoreDataStr = {};
      if (this.tableData.length === 0) {
        this.editScoreScaleDevelopedTitle = "新增评分项目";
        this.operateType = "add";
        this.dialogTableVisible = true;
      } else {
        // 包件数为空的清空(不分包)
        if (this.packList.length === 0) {
          let flag = true;
          this.tableData.forEach(item => {
            if (
              (this.isOld == 1 && item.sscScoreBOS.length != 5) ||
              (this.isOld == 0 && item.sscScoreBOS.length != 4)
            ) {
              flag = false;
            }
          });
          console.log(this.tableData, "this.tableData.........");
          if (
            this.tableData[0].sscScoreBOS.length === 3 &&
            this.evaMethod === "103"
          ) {
            flag = true;
          }
          if (flag) {
            this.$message({
              message:
                "所有包件已经评审完毕，不能进行新增，请选择需要编辑的包件项目",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return;
          } else {
            this.editScoreScaleDevelopedTitle = "新增评分项目";
            this.operateType = "add";
            this.dialogTableVisible = true;
          }
        }
        // 已评审包件数等于包件数，并且每个评审包件的项目已经评审完毕就不能继续新增
        if (this.tableData.length === this.packList.length) {
          let flag = true;
          this.tableData.forEach(item => {
            if (
              (this.isOld == 1 && item.sscScoreBOS.length != 5) ||
              (this.isOld == 0 && item.sscScoreBOS.length != 4)
            ) {
              flag = false;
            }
          });
          if (
            this.tableData[0].sscScoreBOS.length === 3 &&
            this.evaMethod === "103"
          ) {
            flag = true;
          }
          if (flag) {
            this.$message({
              message:
                "所有包件已经评审完毕，不能进行新增，请选择需要编辑的包件项目",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return;
          } else {
            // 如果还有没有评审完毕的项目可以进行评分
            this.editScoreScaleDevelopedTitle = "新增评分项目";
            this.operateType = "add";
            this.dialogTableVisible = true;
          }
        }
        this.editScoreScaleDevelopedTitle = "新增评分项目";
        this.operateType = "add";
        this.dialogTableVisible = true;
      }
    },
    changeCheckbox(index, pIndex, dIndex, e) {
      if (e) {
        this.radioParentIndex = index;
        this.radioIndex = pIndex;
        this.editScoreDataStr = JSON.parse(
          JSON.stringify(this.tableData[index].sscScoreBOS[pIndex])
        );
        this.tableData.forEach((aItem, aIndex) => {
          aItem.sscScoreBOS.forEach((bItem, bIndex) => {
            if (aIndex === index && bIndex === pIndex) {
              this.$set(
                this.tableData[index].sscScoreBOS[pIndex],
                "radio",
                true
              );
            } else {
              this.$set(
                this.tableData[aIndex].sscScoreBOS[bIndex],
                "radio",
                false
              );
            }
          });
        });
        this.$set(this.tableData[index].sscScoreBOS[pIndex], "radio", true);
      } else {
        this.radioParentIndex = "";
        this.radioIndex = "";
        this.$set(this.tableData[index].sscScoreBOS[pIndex], "radio", false);
        this.editScoreDataStr = {};
      }
      let flag = false;
      this.tableData.forEach((aItem, aIndex) => {
        aItem.sscScoreBOS.forEach((bItem, bIndex) => {
          if (bItem.radio) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.radio = "1";
      } else {
        this.radio = "";
      }
    },
    copyData() {
      if (this.radio !== "") {
        if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 2) {
          this.$message({
            message:
              "评审项目已选择完毕，如需调整，请选择需要调整的评审项目进行编辑！",
            type: "warning",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          return;
        } else {
          let flag = true;
          this.tableData.forEach(item => {
            if (item.sscScoreBOS.length != 2) {
              flag = false;
            }
          });
          // 已评审包件数等于包件数，并且每个评审包件的项目已经评审完毕就不能复制
          if (this.tableData.length === this.packList.length && flag) {
            this.$message({
              message:
                "所有包件已经评审完毕，不能进行复制，请选择需要编辑的包件项目",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return false;
          }
          if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 0) {
            this.scoreItemDisabled = false;
          }
          if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 1) {
            this.scoreItemDisabled = true;
            this.editScoreDataStr = JSON.parse(
              JSON.stringify(
                this.tableData[this.radioParentIndex].sscScoreBOS[
                  this.radioIndex
                ]
              )
            );
            this.editScoreDataStr.packId = this.tableData[
              this.radioParentIndex
            ].packId;
            this.editScoreDataStr.packName = this.tableData[
              this.radioParentIndex
            ].packName;
            if (
              this.tableData[this.radioParentIndex].sscScoreBOS[0].scoreItem ===
              "1"
            ) {
              this.$set(this.editScoreDataStr, "scoreItem", "0");
              this.$set(this.editScoreDataStr, "scoreItemStr", "技术");
            } else {
              this.$set(this.editScoreDataStr, "scoreItem", "1");
              this.$set(this.editScoreDataStr, "scoreItemStr", "商务");
            }
          }
          this.editScoreScaleDevelopedTitle = "复制评分项目";
          this.operateType = "copy";
          this.dialogTableVisible = true;
        }
      } else {
        this.$message({
          message: "请选择需要复制的包件的评审项目！",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    editData() {
      if (this.radio !== "") {
        this.scoreItemDisabled = true;
        this.editScoreScaleDevelopedTitle = "编辑评分项目";
        this.operateType = "edit";
        this.editScoreDataStr = JSON.parse(
          JSON.stringify(
            this.tableData[this.radioParentIndex].sscScoreBOS[this.radioIndex]
          )
        );
        this.editScoreDataStr.packId = this.tableData[
          this.radioParentIndex
        ].packId;
        this.editScoreDataStr.packName = this.tableData[
          this.radioParentIndex
        ].packName;
        this.dialogTableVisible = true;
      } else {
        this.$message({
          message: "请选择要编辑的包件的评审项目！",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 确定新增、编辑、复制评分
    confirmEditScoreScale() {
      this.$refs.editScoreScaleDeveloped.$refs["editScoreDataForm"].validate(
        valid => {
          this.$refs.editScoreScaleDeveloped.$refs[
            "editScoreDataForm2"
          ].validate(valid2 => {
            if (valid && valid2) {
              let radioParentIndexnew = 0;
              let radioIndexnew = 0;
              let dataForm = this.$refs.editScoreScaleDeveloped._data
                .editScoreData;
              console.log(dataForm, "dataForm.tableData............");
              if (dataForm.tableData && dataForm.tableData.length === 0) {
                this.$message({
                  message: "请添加评审细则项目",
                  type: "error",
                  duration: 3000,
                  ccuiCustom: true,
                  showClose: true,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
                return false;
              }
              let arr1 = [];
              for (let i = 0; i < dataForm.tableData.length; i++) {
                if (!dataForm.tableData[i].scoreRule) {
                  this.$message({
                    message: "第" + (i + 1) + "行的评审细则不能为空！",
                    type: "error",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                  return false;
                }
                if (
                  dataForm.tableData[i].scoreWeight === null ||
                  dataForm.tableData[i].scoreWeight === undefined ||
                  dataForm.tableData[i].scoreWeight === ""
                ) {
                  if (!dataForm.tableData[i].free2) {
                    this.$message({
                      message: "第" + (i + 1) + "行的细则权重不能为空",
                      type: "error",
                      duration: 3000,
                      ccuiCustom: true,
                      showClose: true,
                      offset: document.documentElement.clientHeight / 2 - 21
                    });
                    return false;
                  } else {
                    if (dataForm.tableData[i].free2 == "1") {
                      this.$message({
                        message: "第" + (i + 1) + "行的细则权重不能为空",
                        type: "error",
                        duration: 3000,
                        ccuiCustom: true,
                        showClose: true,
                        offset: document.documentElement.clientHeight / 2 - 21
                      });
                      return false;
                    }
                  }
                }
                if (
                  dataForm.scoreItem == "5" &&
                  (dataForm.tableData[i].scoreWeight === 0 ||
                    dataForm.tableData[i].scoreWeight === "0")
                ) {
                  this.$message({
                    message: "第" + (i + 1) + "行的细则权重不能为0",
                    type: "error",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                  return false;
                }
                if (
                  dataForm.scoreItem == "5" &&
                  dataForm.tableData[i].free3 == 1
                ) {
                  arr1.push(dataForm.tableData[i].scoreWeight);
                  if (dataForm.tableData[i].scoreWeight > 1) {
                    this.$message({
                      message: "第" + (i + 1) + "行的细则权重不能大于1",
                      type: "error",
                      duration: 3000,
                      ccuiCustom: true,
                      showClose: true,
                      offset: document.documentElement.clientHeight / 2 - 21
                    });
                    return false;
                  }
                }
                if (!dataForm.tableData[i].scoreStandard) {
                  this.$message({
                    message: "第" + (i + 1) + "行的评审标准不能为空",
                    type: "error",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                  return false;
                }
              }
              arr1 = Array.from(new Set(arr1));
              if (dataForm.scoreItem == "5" && arr1.length != 3) {
                this.$message({
                  message: "投标报价系数细则权重不能相同！",
                  type: "error",
                  duration: 3000,
                  ccuiCustom: true,
                  showClose: true,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
                return false;
              }
              if (this.radio !== "") {
                radioParentIndexnew = this.radioParentIndex;
                radioIndexnew = this.radioIndex;
              }
              // 新增
              console.log(this.operateType, "this.operateType......");
              console.log(this.tableData, "this.tableData......");

              if (this.operateType === "add") {
                if (this.tableData.length === 0) {
                  this.tableData.unshift({
                    packId: dataForm.packId,
                    packName: dataForm.packName,
                    sscScoreBOS: [
                      {
                        radio: false,
                        scoreItem: dataForm.scoreItem,
                        scoreItemStr: dataForm.scoreItemStr,
                        sumForm: dataForm.sumForm,
                        weight: dataForm.weight,
                        sscScoreItemBOS: dataForm.tableData
                      }
                    ]
                  });
                } else {
                  // 是否分包
                  if (this.subPackageFlag == "1") {
                    // 分包
                    // 查看tableData中是否存在此包件
                    let existPacgFlag = false;
                    let existIndex = 0;
                    try {
                      this.tableData.forEach((item, index) => {
                        if (item.packId === dataForm.packId) {
                          existPacgFlag = true;
                          existIndex = index;
                          throw Error();
                        }
                      });
                    } catch (e) {
                      console.log(e);
                    }
                    if (existPacgFlag) {
                      this.tableData[existIndex].sscScoreBOS.unshift({
                        radio: false,
                        scoreItem: dataForm.scoreItem,
                        scoreItemStr: dataForm.scoreItemStr,
                        sumForm: dataForm.sumForm,
                        weight: dataForm.weight,
                        sscScoreItemBOS: dataForm.tableData
                      });
                    } else {
                      this.tableData.unshift({
                        packId: dataForm.packId,
                        packName: dataForm.packName,
                        sscScoreBOS: [
                          {
                            radio: false,
                            scoreItem: dataForm.scoreItem,
                            scoreItemStr: dataForm.scoreItemStr,
                            sumForm: dataForm.sumForm,
                            weight: dataForm.weight,
                            sscScoreItemBOS: dataForm.tableData
                          }
                        ]
                      });
                    }
                  } else {
                    // 不分包
                    this.tableData[0].sscScoreBOS.unshift({
                      radio: false,
                      scoreItem: dataForm.scoreItem,
                      scoreItemStr: dataForm.scoreItemStr,
                      sumForm: dataForm.sumForm,
                      weight: dataForm.weight,
                      sscScoreItemBOS: dataForm.tableData
                    });
                  }
                }
              }
              // 编辑
              if (this.operateType === "edit") {
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].sumForm = dataForm.sumForm;
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].weight = dataForm.weight;
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].sscScoreItemBOS = dataForm.tableData;
              }
              // 复制
              if (this.operateType === "copy") {
                this.tableData[radioParentIndexnew].sscScoreBOS.unshift({
                  radio: false,
                  scoreItem: dataForm.scoreItem,
                  scoreItemStr: dataForm.scoreItemStr,
                  sumForm: dataForm.sumForm,
                  weight: dataForm.weight,
                  sscScoreItemBOS: dataForm.tableData
                });
              }
              let weight = 0;
              this.tableData[radioParentIndexnew].sscScoreBOS[
                radioIndexnew
              ].sscScoreItemBOS.forEach(item => {
                weight += Number(item.scoreWeight);
              });
              if (
                this.tableData[radioParentIndexnew].sscScoreBOS[radioIndexnew]
                  .scoreItem !== "5"
              ) {
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].weight = weight;
              }
              // if (this.radio) {
              this.tableData.forEach((aItem, aIndex) => {
                aItem.sscScoreBOS.forEach((bItem, bIndex) => {
                  // if (
                  //   aIndex === radioParentIndexnew &&
                  //   bIndex === radioIndexnew
                  // ) {
                  //   this.$set(
                  //     this.tableData[aIndex].sscScoreBOS[bIndex],
                  //     "radio",
                  //     true
                  //   );
                  // } else {
                  this.$set(
                    this.tableData[aIndex].sscScoreBOS[bIndex],
                    "radio",
                    false
                  );
                  // }
                });
              });
              // }
              this.editStatusIndex();
              console.log(this.radioParentIndex, "this.radioParentIndex");
              // this.$set(
              //   this.tableData[this.radioParentIndex].sscScoreBOS[
              //     this.radioIndex
              //   ],
              //   "radio",
              //   false
              // );
              this.editScoreDataStr = {};
              this.radioParentIndex = "";
              this.radioIndex = "";
              this.radio = "";
              this.dialogTableVisible = false;
            }
          });
        }
      );
    },
    // 编辑状态下的序号展示
    editStatusIndex() {
      console.log(this.tableData, "this.tableData///");
      let index = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.tableData[i].sscScoreBOS.length; j++) {
          index += 1;
          this.tableData[i].sscScoreBOS[j].showIndex = index;
          if (this.operateType == "add" || this.operateType == "delete") {
            this.$set(this.tableData[i].sscScoreBOS[j], "radio", false);
          }
        }
      }
    },
    save(type) {
      let confirmMessage = type == 2 ? "生效" : "保存";
      this.$confirm(`您确定${confirmMessage}此评分表制定吗？`, "评分表确定", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          let errorMessage = "";
          if (type === 2) {
            // 生效
            let packList = JSON.parse(JSON.stringify(this.packList));
            packList.length === 0 && packList.push({ packId: 0 });
            console.log("packList", packList);
            console.log("tableData", this.tableData);
            for (let i = 0; i < packList.length; i++) {
              let data = this.tableData.filter(
                item =>
                  (item.packId === null ? 0 : item.packId) ===
                  packList[i].packId
              );
              let count = 0,
                weight = 0,
                bidScro = 0;
              console.log(data, "data");
              if (data.length !== 0) {
                if (this.evaMethod === "103") {
                  // 只校验商务评分和投标评分
                  data[0].sscScoreBOS.forEach(aItem => {
                    if (aItem.scoreItem === "1" || aItem.scoreItem === "5") {
                      if (aItem.scoreItem === "5") {
                        // 投标评分权重必须大于70
                        bidScro = Number(aItem.weight);
                      }
                      count += 1;
                      weight += Number(aItem.weight);
                    }
                  });
                } else {
                  data[0].sscScoreBOS.forEach(aItem => {
                    if (
                      aItem.scoreItem === "0" ||
                      aItem.scoreItem === "1" ||
                      aItem.scoreItem === "5"
                    ) {
                      if (aItem.scoreItem === "5") {
                        // 投标评分权重必须大于70
                        bidScro = Number(aItem.weight);
                      }
                      count += 1;
                      weight += Number(aItem.weight);
                    }
                  });
                }
                console.log(this.evaMethod, "this.evaMethod");
                console.log(count, "count");
                if (
                  (this.evaMethod === "103" && count < 1) ||
                  (this.isOld == 1 &&
                    this.evaMethod !== "103" &&
                    count !== 3) ||
                  (this.isOld == 0 && this.evaMethod !== "103" && count !== 2)
                ) {
                  errorMessage =
                    "此评分表中存在未定义完成的包件评审项目，不允许提交生效，请您确认后再操作！";
                  break;
                } else if (weight !== 100) {
                  if (this.subPackageFlag === "1") {
                    errorMessage =
                      "包件【" +
                      this.packList[i].packName +
                      "】的”项目权重“或”细则权重“之和不等于100，不允许进行提交生效，请您确认后再操作！";
                  } else {
                    errorMessage =
                      "”项目权重“或”细则权重“之和不等于100，不允许进行提交生效，请您确认后再操作！";
                  }
                  break;
                } else if (bidScro < 70 && this.isOld == 1) {
                  errorMessage =
                    "此评分表中投标报价评分项目权重不能小于70，不允许提交生效，请您确认后再操作！";
                }
              } else {
                errorMessage =
                  "此评分表中存在未定义完成的包件评审项目，不允许提交生效，请您确认后再操作！";
                break;
              }
            }
          }
          if (errorMessage === "") {
            console.log(this.tableData, "this.tableData...");
            let sscScoreBOS = [];
            this.tableData.forEach(item => {
              item.sscScoreBOS.forEach(aItem => {
                let obj = {};
                obj.packId = item.packId;
                obj.packName = item.packName;
                obj.scoreItem = aItem.scoreItem;
                obj.scoreItemStr = aItem.scoreItemStr;
                obj.weight = aItem.weight;
                if (this.checked) {
                  // 去掉最低分和最高分（仅限技术评分）
                  obj.sumForm = "102";
                } else {
                  // obj.sumForm = aItem.sumForm;
                  obj.sumForm = "101";
                }
                if (aItem.scoreItem == "5") {
                  aItem.sscScoreItemBOS.push(this.saveItem);
                }
                obj.sscScoreItemBOS = aItem.sscScoreItemBOS;
                sscScoreBOS.push(obj);
              });
            });
            scpDealExpertScoreFormulateApi({
              operType: type,
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              sscScoreBOS: sscScoreBOS,
              operIdentity: "2"
            }).then(res => {
              this.init();
              this.$message({
                message: type === 1 ? "保存成功" : "生效成功！",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.editStatus = false;
            });
          } else {
            this.$message({
              message: errorMessage,
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        })
        .catch(() => {});
    },
    // 导出开始
    exportPdf() {
      this.exportData = [];
      if (this.tableData > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        let id = 0;
        this.tableData.forEach((item, index) => {
          item.sscScoreBOS.forEach(aItem => {
            aItem.sscScoreItemBOS.forEach(bItem => {
              this.exportData.push({
                // id: 1 + index,
                id: id++,
                packName: item.packName,
                scoreItemStr: aItem.scoreItemStr,
                weight: aItem.weight,
                scoreRule: bItem.scoreRule,
                scoreWeight: bItem.scoreWeight,
                scoreStandard: bItem.scoreStandard
              });
            });
          });
        });
        if (this.ExcelJS) {
          this.exportDefaultAll();
        } else {
          this.exportCompatibleAll();
        }
      }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("评分表制定列表");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["评分表制定列表"]);
      ws1.addRow([this.content]);
      if (this.subPackageFlag === "1") {
        ws1.addRow([
          "序号",
          "包件名称",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ]);
        ws1.columns = [
          { key: "id", width: 5 },
          { key: "packName", width: 25 },
          { key: "scoreItemStr", width: 25 },
          { key: "weight", width: 25 },
          { key: "scoreRule", width: 50 },
          { key: "scoreWeight", width: 25 },
          { key: "scoreStandard", width: 50 }
        ];
      } else {
        ws1.addRow([
          "序号",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ]);
        ws1.columns = [
          { key: "id", width: 5 },
          { key: "scoreItemStr", width: 25 },
          { key: "weight", width: 25 },
          { key: "scoreRule", width: 50 },
          { key: "scoreWeight", width: 25 },
          { key: "scoreStandard", width: 50 }
        ];
      }

      let oneSpanList = [];
      let twoSpanList = [];
      let start = 4;
      let twoStart = 4;
      console.log("this.tableData", this.tableData);
      this.tableData.forEach((item, index) => {
        let devspan = 0;
        item.sscScoreBOS.forEach(a => {
          devspan += a.sscScoreItemBOS.length;
        });
        item.sscScoreBOS.forEach((aItem, aIndex) => {
          let twoDevSpan = 0;
          twoDevSpan += aItem.sscScoreItemBOS.length;
          aItem.sscScoreItemBOS.forEach(bItem => {
            if (this.subPackageFlag === "1") {
              ws1.addRow([
                index + 1,
                item.packName,
                aItem.scoreItemStr,
                aItem.weight,
                bItem.scoreRule,
                bItem.scoreWeight,
                bItem.scoreStandard
              ]);
            } else {
              ws1.addRow([
                index + 1,
                aItem.scoreItemStr,
                aItem.weight,
                bItem.scoreRule,
                bItem.scoreWeight,
                bItem.scoreStandard
              ]);
            }
          });
          twoSpanList.push({
            start: twoStart,
            end: twoDevSpan + twoStart - 1
          });
          twoStart = twoDevSpan + twoStart;
        });
        oneSpanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      oneSpanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        if (this.subPackageFlag === "1") {
          ws1.mergeCells("B" + item.start + ":B" + item.end);
        }
      });
      twoSpanList.forEach(item => {
        if (this.subPackageFlag === "1") {
          ws1.mergeCells("D" + item.start + ":D" + item.end);
        } else {
          ws1.mergeCells("B" + item.start + ":B" + item.end);
        }
        ws1.mergeCells("C" + item.start + ":C" + item.end);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "评分表制定列表.xlsx");
    },
    exportCompatibleAll() {
      let header = [],
        filterVal = [];
      if (this.subPackageFlag === "1") {
        header = [
          "序号",
          "包件名称",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ];
        filterVal = [
          "id",
          "packName",
          "scoreItemStr",
          "weight",
          "scoreRule",
          "scoreWeight",
          "scoreStandard"
        ];
      } else {
        header = [
          "序号",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ];
        filterVal = [
          "id",
          "scoreItemStr",
          "weight",
          "scoreRule",
          "scoreWeight",
          "scoreStandard"
        ];
      }

      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "评分表制定列表"
      });
    },
    // 下载模板
    downloadPdf() {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      // openUrl.href = `${this.$addUrlPerFix(
      //   process.env.VUE_APP_BASE_URL
      // )}/apis/scma/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      let url = "";
      let name = "";
      if (this.subPackageFlag === "1") {
        url =
          "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100065/104316/default/202304/67b91472e00b4c2797211c71ac2a625c.xlsx";
        name = "评分表制定模板-多包";
      } else {
        url =
          "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com:443/cccc_home/100065/104316/default/202304/8198b861ae9e4514abb6ab819b379d92.xlsx";
        name = "评分表制定模板-单包";
      }
      openUrl.href = url;
      console.log(openUrl.href);
      openUrl.setAttribute("download", name);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    beforeAvatarUpload(file) {
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS";
      if (!isLt50) {
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      //是否有后缀
      let fileType = file.name.indexOf(".") != -1;
      if (!extension && fileType) {
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && (extension || !fileType);
    },
    uploadSuccess(res, file, fileList) {
      if (res.code === "0") {
        // let data = [];
        // let devspan = 0;
        // let devspantow = 0;
        // let id = 0;
        let packs = JSON.parse(this.formData.packs);
        let isTrue = true;
        if (packs.length > 0) {
          if (res.data && res.data.length > 0) {
            res.data.forEach(bb => {
              if (bb.packId == "0" || bb.packId == null) {
                this.$message({
                  message: "请导入正确的评分模板",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                isTrue = false;
              }
            });
          }
        }
        if (isTrue) {
          if (res.data && res.data.length > 0) {
            if (packs.length > 0) {
              packs.forEach(item => {
                this.$set(item, "sscScoreBOS", []);
                res.data.forEach(bb => {
                  if (bb.packId == item.packId) {
                    item.sscScoreBOS.push(bb);
                  }
                });
              });
            } else {
              let obj = {
                packId: null,
                packName: null,
                sscScoreBOS: []
              };
              res.data.forEach(bb => {
                obj.sscScoreBOS.push(bb);
              });
              packs.push(obj);
            }

            let newPacksData = JSON.parse(JSON.stringify(packs));
            for (let a = 0; a < newPacksData.length; a++) {
              let item = newPacksData[a];
              let packName = item.packId ? "包" + item.packName + "的" : "";
              for (let b = 0; b < item.sscScoreBOS.length; b++) {
                let num = 0;
                let itemTwo = item.sscScoreBOS[b];
                for (let c = 0; c < itemTwo.sscScoreItemBOS.length; c++) {
                  let itemThree = itemTwo.sscScoreItemBOS[c];
                  // if (itemTwo.scoreItem !== 2 && itemTwo.scoreItem !== 3) {
                  num += itemThree.scoreWeight;
                  // }

                  if (itemTwo.scoreItemStr == "") {
                    this.$message({
                      type: "error",
                      message: `${packName}评审项目不能为空，请重新导入!`,
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });

                    return false;
                  }
                  if (itemTwo.weight == "") {
                    this.$message({
                      type: "error",
                      message: `${packName}项目权重不能为空，请重新导入!`,
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });

                    return false;
                  }

                  if (itemThree.scoreRule == "") {
                    this.$message({
                      type: "error",
                      message: `${packName}${itemTwo.scoreItemStr}的评审细则不能为空，请重新导入!`,
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });

                    return false;
                  }
                  if (itemThree.scoreWeight == "") {
                    this.$message({
                      type: "error",
                      message: `${packName}${itemTwo.scoreItemStr}的细则权重不能为空，请重新导入!`,
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });

                    return false;
                  }

                  if (itemThree.scoreStandard == "") {
                    this.$message({
                      type: "error",
                      message: `${packName}${itemTwo.scoreItemStr}的评审标准不能为空，请重新导入!`,
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });
                    return false;
                  }
                  if (
                    itemTwo.weight !== num &&
                    c + 1 == itemTwo.sscScoreItemBOS.length
                  ) {
                    this.$message({
                      message: `${packName}${itemTwo.scoreItemStr}的项目权重与细则权重之和不相等，请重新导入`,
                      type: "error",
                      duration: 3000,
                      ccuiCustom: true,
                      showClose: true,
                      offset: document.documentElement.clientHeight / 2 - 21
                    });
                    return false;
                  }

                  if (
                    itemTwo.weight > 100 &&
                    itemTwo.scoreItem != 2 &&
                    itemTwo.scoreItem != 3
                  ) {
                    this.$message({
                      message: `${packName}${itemTwo.scoreItemStr}的项目权重必须在0~100之间，请重新导入`,
                      type: "error",
                      duration: 3000,
                      ccuiCustom: true,
                      showClose: true,
                      offset: document.documentElement.clientHeight / 2 - 21
                    });
                    return false;
                  }
                }
              }
            }
            let arr = [];
            // 合并评分细则
            for (let i = 0; i < newPacksData.length; i++) {
              let item = JSON.parse(JSON.stringify(newPacksData[i]));
              item.sscScoreBOS = [];
              for (let y = 0; y < newPacksData[i].sscScoreBOS.length; y++) {
                if (item.sscScoreBOS.length === 0) {
                  item.sscScoreBOS.push(newPacksData[i].sscScoreBOS[y]);
                } else {
                  // 查找当前细则有没有，有的话直接添加，没有的话新加这个细则
                  let flag = true;
                  item.sscScoreBOS.forEach(item1 => {
                    if (
                      item1.scoreItemStr ===
                      newPacksData[i].sscScoreBOS[y].scoreItemStr
                    ) {
                      flag = false;
                      item1.sscScoreItemBOS.push(
                        ...newPacksData[i].sscScoreBOS[y].sscScoreItemBOS
                      );
                      item1.weight += newPacksData[i].sscScoreBOS[y].weight;
                    }
                  });
                  if (flag) {
                    item.sscScoreBOS.push(newPacksData[i].sscScoreBOS[y]);
                  }
                }
              }
              arr.push(item);
            }
            console.log(arr, "arr///");
            this.tableData = JSON.parse(JSON.stringify(arr));
          }
        }

        console.log(this.tableData, "导入之后的数据");
      }
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chooseCheck {
  //position: absolute;
  //top: 70px;
  //left: 110px;
  margin-left: 30px;
}
.fr {
  float: right;
}

.wd2 {
  width: 36px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
.el-radio-group {
  display: contents;
}
.lastrightcell {
  border-right: none;
}
.lastbottomcell {
  border-bottom: none;
}
.uploadClass {
  display: inline-block;
  margin-left: 10px;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
</style>
